import React, { FC, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

import { useSearchQuery } from '../../lib/hooks/search-query';


const OPTIONS = [
    { label: 'すベて', value: '', img: 'icon-store.png' },
    /*
    { label: 'テイクアウト', value: 'テイクアウト', img: 'icon-take.png' },
    { label: 'デリバリー', value: 'デリバリー', img: 'icon-delivery.png' },
    */
    { label: 'クーポン', value: 'クーポン', img: 'coupon.png' },
    { label: '飲食店', value: '飲食店', img: 'icon-rest.png' },
    { label: 'ヘアサロン', value: 'ヘアサロン', img: 'icon-cut.png' },
    { label: '健康', value: '健康', img: 'icon-health.png' },
    { label: '医療・福祉', value: '医療・福祉', img: 'icon-medical.png' },
    { label: 'CHIMNEY COFFEE取扱', value: 'CHIMNEY COFFEE取扱', img: 'icon-chimneycoffee.png' },
    { label: 'スナック\nキャンディ', value: 'スナックキャンディ', img: 'icon-candy.png' },
    { label: '宿泊', value: '宿泊', img: 'icon-hotel.png' },
    { label: '自販機', value: '自販機', img: 'icon-vend.png' },
    { label: 'その他', value: 'その他', img: 'icon-other.png' },
];


type Props = {
    onSubmit(data: {
        area: string;
        genre: string;
        keyword: string;
    }): void;
};


export const MapMenuBar: FC<Props> = ({ onSubmit }) => {
    const [open, setOpen] = useState(false);
    const { register, handleSubmit, setValue } = useForm();
    const { query, setQuery } = useSearchQuery();

    useEffect(() => {
        onSubmit(query);
    }, []);

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <select
                id="genre"
                ref={register}
                name="genre"
                defaultValue=""
                value={query.genre}
                onClick={() => setOpen(!open)}
            >
                {OPTIONS.map(option => <option value={option.value}></option>)}
            </select>
            <label htmlFor="genre">
                <div className="selected-option">
                    <img className="option-image" src={`/img/map_menu_icons/${OPTIONS.filter((option) => option.value === query.genre)[0].img}`} />
                    <span className="option-label">
                        {OPTIONS.filter((option) => option.value === query.genre)[0].label}
                    </span>
                </div>
            </label>
            <ul className={open ? "select-box open" : "select-box close"}>
                {OPTIONS.map((option) => (
                    <li className="option" onClick={() => {
                        setOpen(!open);
                        setValue('genre', option.value);
                        setQuery(prev => ({
                            ...prev,
                            genre: option.value,
                        }));
                        onSubmit({ ...query, genre: option.value });
                    }}>
                        <img className="option-image" src={`/img/map_menu_icons/${option.img}`} />
                        <span className="option-label">{option.label}</span>
                    </li>
                ))}
            </ul>
            <input
                ref={register}
                name="keyword"
                defaultValue=""
                value={query.keyword}
                placeholder="キーワード"
                onChange={(e) => setQuery(prev => ({
                    ...prev,
                    keyword: e.target.value,
                }))}
            />
            <input
                ref={register}
                name="area"
                defaultValue=""
                placeholder="エリア"
                onChange={(e) => setQuery(prev => ({
                    ...prev,
                    area: e.target.value,
                }))}
            />
            <button type="submit" className="search-button">
                <img src="/img/icon_search_white.png" alt="検索ボタン" />
            </button>

            <style jsx>{`
                form {
                    position: relative;
                    display: flex;
                    background: #fff;
                    padding: 0;
                }
                select {
                    display: none;
                }
                input,
                .selected-option {
                    font-size: 14px;
                    height: 38px;
                    border: solid 2px #f7f7f7;
                    outline: none;
                    appearance: none;
                    padding-left: 14px;
                }
                label {
                    cursor: pointer;
                }
                .select-box {
                    padding: 0;
                    margin: 0;
                    list-style-type: none;
                    position: absolute;
                    top: 38px;
                    z-index: 8;
                }
                .select-box > li {
                    display: flex;
                    align-items: center;
                    padding: 6px;
                    padding-left: 12px;
                    height: 40px;
                }
                .selected-option {
                    width: 140px;
                    background: #fff;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    padding: 0;
                    padding-left: 12px;
                    display: flex;
                    align-items: center;
                }
                .option {
                    width: 140px;
                    height: 40px;
                    display: flex;
                    align-items: center;
                    background: #fff;
                    cursor: pointer;
                }
                .option-image {
                    max-height: 35px;
                    max-width: 35px;
                }
                .option-label {
                    font-size: 13px;
                    margin-left: 4px;
                }
                .close > li {
                    height: 0px;
                    visibility: hidden;
                    transition:
                        height .3s ease-out,
                        opacity .1s linear,
                        visibility .1s linear;
                }
                .open > li {
                    transition:
                        height .5s ease-out,
                        opacity .1s linear .1s,
                        visibility .1s linear .1s;
                }
                input {
                    width: 50%;
                    border-right: none;
                }
                .search-button {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background-color: #fe8125;
                    border: solid 2px #f7f7f7;
                    padding: none;
                    width: 38px;
                    height: 38px;
                    cursor: pointer;
                }
                .search-button > img {
                    width: 20px;
                    height: 20px;
                }
                @media screen and (max-width: 874px) {
                    .select-box > li {
                        padding-left: 4px;
                    }
                    input,
                    .selected-option {
                        font-size: 10px;
                        height: 34px;
                    }
                    .selected-option {
                        width: 110px;
                        padding-left: 8px;
                    }
                    .option-label {
                        font-size: 8px;
                    }
                    .option-image {
                        max-height: 30px;
                        max-width: 30px;
                    }
                    .option {
                        width: 110px;
                        padding-left: 8px;
                    }
                    .search-button {
                        width: 34px;
                        height: 34px;
                    }
                    .select-box {
                        top: 34px;
                    }
                }
            `}</style>
        </form>
    );
};
